import React from 'react';
import { Hero } from './components/Hero';
import { GmailReviews } from './components/GmailReviews';
import { Problems } from './components/Problems';
import { Modules } from './components/Modules';
import { Benefits } from './components/Benefits';
import { Bonuses } from './components/Bonuses';
import { Comparison } from './components/Comparison';
import { Testimonials } from './components/Testimonials';
import { FinalOffer } from './components/FinalOffer';
import { Objections } from './components/Objections';
import { Support } from './components/Support';
import { PurchasePopup } from './components/PurchasePopup';
import { useMetaPixel } from './hooks/useMetaPixel';
export function App() {
  useMetaPixel('1555763442913803');
  return <div className="relative min-h-full w-full bg-[#f6f3ec]" data-id="element-0" data-mp="2wifh3h2wjf0a">
      <div className="studio-bg" aria-hidden="true" data-id="element-1" data-mp="28tmex2vosax8" />
      <div className="studio-bg-veil" aria-hidden="true" data-id="element-2" data-mp="28sb9kymlev40" />

      <main className="relative z-10 mx-auto w-full max-w-md" data-id="element-3" data-mp="23u9vks40xlze">
        <Hero data-id="element-4" data-mp="3ik7gihlkcdr6" />
        <GmailReviews data-id="element-5" data-mp="3ikh5c1uvgeva" />
        <Problems data-id="element-6" data-mp="3ij63w8owfj7c" />
        <Modules data-id="element-7" data-mp="3ijpd910hgz9r" />
        <Benefits data-id="element-8" data-mp="3ii4ro0w5cqo1" />
        <Bonuses data-id="element-9" data-mp="3mlayb9n68jv1" />
        <Comparison data-id="element-10" data-mp="3mkrc3gqhn9b7" />
        <Testimonials data-id="element-11" data-mp="3mk83iqmq9x9u" />
        <FinalOffer data-id="element-12" data-mp="3mjga9mglsbmq" />
        <Objections data-id="element-13" data-mp="3rc9ca2kot5v4" />
        <Support data-id="element-14" data-mp="3rbrcwx2qabiz" />
      </main>

      <PurchasePopup data-id="element-15" data-mp="3rcsyhvhdegey" />
    </div>;
}